export interface LandUseClassModelFromApi {
  Id: string;
  Name: string;
  Children?: LandUseClassModelFromApi[];
}

export class LandUseClassModel {
  constructor(
    public id: string,
    public name: string,
    public children: LandUseClassModel[],
  ) {}

  static fromApi(data: LandUseClassModelFromApi): LandUseClassModel {
    return new this(
      data.Id,
      data.Name,
      (data.Children || []).map((child) => LandUseClassModel.fromApi(child)),
    );
  }
}
